export default "__VITE_ASSET__ff684eaa__"